// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckboxCell_checkbox__X2c6V","checked":"CheckboxCell_checked__5-ezp","checkmark":"CheckboxCell_checkmark__7e3rO","readOnly":"CheckboxCell_readOnly__461jt"};